import { NameDto } from 'api/Common/Types'

export interface PlatformTypeDto {
  id: PlatformTypeId
  name: string
  platformType: NameDto
  enabled: boolean
}

export enum PlatformTypeId {
  MT4 = 1,
  MT5 = 2,
  CQGCast = 3,
  TickmillTrader = 4,
}

export const PlatformTypeName = {
  [PlatformTypeId.MT4]: 'MT4',
  [PlatformTypeId.MT5]: 'MT5',
  [PlatformTypeId.CQGCast]: 'CQG Cast',
  [PlatformTypeId.TickmillTrader]: 'Tickmill Trader',
}

export const isCQGCastPlatform = (platformTypeId: PlatformTypeId) =>
  platformTypeId === PlatformTypeId.CQGCast

export const isMT5Platform = (platformTypeId: PlatformTypeId) =>
  platformTypeId === PlatformTypeId.MT5
